// extracted by mini-css-extract-plugin
export default {"newsscroll":"newsmain_newsscroll__RIC3B","scroll":"newsmain_scroll__z3jt0","newscontainer":"newsmain_newscontainer__zKnDo","image":"newsmain_image__oDdpE"};